/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Pagination,
  Col,
  Table,
  OverlayTrigger,
  ControlLabel,
  FormGroup,
  FormControl,
  Modal,
  Tooltip,
} from "react-bootstrap";
import {
  updateOrdersRider,
  updatesubscriptionOrderStatus,
  updateSubscriptionRider,
  Updatereview,
  getallrider,
  updateOrderStatus,
  searchsubscriptionOrders,
  DeleteSubscriptionOrder,
  DownloadOrder,
  updatepaymentinfo,
  getb2b,
  subscriptionfilter,
  GetSubscription,
  updateSubscriptionDeliveryStatus,
  CancelSubscriptionOrder,
  ChargeSubscriptionOrder,
} from "../../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import Switch from "react-bootstrap-switch";
import SweetAlert from "react-bootstrap-sweetalert";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
const moment = extendMoment(originalMoment);

export const CheckBox = (props) => {
  return (
    <li>
      <input
        key={props.id}
        onClick={props.handleCheckChieldElement}
        type="checkbox"
        checked={props.isChecked}
        value={props.value}
      />{" "}
      {props.value}
    </li>
  );
};
class subscriptionpackagefilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfloading: false,
      order_details: [],
      order_chk: [],
      selected_id: [],
      loading: false,
      bulkSelect: null,
      subscriber: "",
      rider_id: "",
      source: "",
      status: "",
      page: "",
      paginationData: [],
      noRecordFound: false,
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      deliveryType: "",
      alert: null,
      viewinvoice: "",
      useraccess: "",
      orderdate: "",
      processing: true,
      channel_filter: "",
      order_id_filter: "",
      fromdate_filter: "",
      todate_filter: "",
      todateerror: null,
      p_orderid: "",
      p_total_cost: "",
      p_paid_amount: "",
      showpaymentdetailmodal: false,
      _notificationSystem: null,
      paymenttype: "",
      f_paymenttype: "",
      remainpaymentamount: "0",
      paidamount: 0,
      errormessages: [],
      cancelorderModal: false,
      ridermodel: false,
      ordercancelreason: "",
      paymentoption: "",
      cancel_reason_display_Modal: false,
      show_charge_message: false,
      charge_message: "",
      Cancel_reason_state: "",
      ordercancelreasonError: null,
      rider_details: [],
      b2b: "",
      b2bDetails: [],
      rider_info: null,
      rider_infoError: null,
      rider_data: [],
      value: "",
      isdaterangepickerOpen: false,
      rider_details: [],
      time: "",
      processing: false,

      package_id: [],
      package_details: [],
      Package_items: [],
      deliverydate: "",
      select_order: [],
    };
    this.onStatusChange = this.onStatusChange.bind(this);
    this.editOrder = this.editOrder.bind(this);
    this.searchData = this.searchData.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getdata = this.getdata.bind(this);
    this.deleteorderdetails = this.deleteorderdetails.bind(this);
    this.handleUpdaterider = this.handleUpdaterider.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.warningWithConfirmAndCancelMessage2 =
      this.warningWithConfirmAndCancelMessage2.bind(this);
    this.cancelSubscription = this.cancelSubscription.bind(this);
    this.viewpdf = this.viewpdf.bind(this);
    this.onpaymentchange = this.onpaymentchange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.downloadpre = this.downloadpre.bind(this);
    this.oncancelchnage = this.oncancelchnage.bind(this);
    this.saverider = this.saverider.bind(this);
    this.deliveryDone = this.deliveryDone.bind(this);
    this.formatDate = this.formatDate.bind(this);
  }
  handleDateChange = (date) => {
    this.setState({
      deliverydate: date,
    });
  };

  onSelect = (value, states) => {
    this.setState({ value, states });
  };

  onToggle() {
    this.setState({ isdaterangepickerOpen: !this.state.isdaterangepickerOpen });
  }
  deliveryDone() {
    let sts_arr = [];
    this.state.order_chk.map((item) => {
      if (item.isChecked) {
        this.state.selected_id.push({ id: item.id });
        sts_arr.push({ id: item.id });
      }
    });
    if (sts_arr.length > 0) {
      // update order detail
      let error = false;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      let order_id = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          order_id.push(item.id);
        }
      });
      var dtoday = "";
      if (this.state.deliverydate.length != 0) {
        const deliverydate = new Date(this.state.deliverydate);

        var ddd = ("0" + deliverydate.getDate()).slice(-2);
        var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
        var dyyyy = deliverydate.getFullYear();
        dtoday = dyyyy + "-" + dmm + "-" + ddd;
      } else {
        dtoday = "";
      }
      updateSubscriptionDeliveryStatus(order_id, dtoday, obj).then((res) => {
        // console.log(res,'update delivery status');
        this.searchData();
        this.setState({
          selected_id: [],
          ridermodel: false,
          bulkSelect: "",
          rider_info: null,
          rider_infoError: null,
        });
      });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please select order!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    }
  }
  saverider() {
    let sts_arr = [];
    this.state.order_chk.map((item) => {
      if (item.isChecked) {
        this.state.selected_id.push({ id: item.id });
        sts_arr.push({ id: item.id });
      }
    });
    if (sts_arr.length > 0) {
      this.setState({ ridermodel: true });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please select order!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    }
  }
  warningWithConfirmAndCancelMessage2(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.cancelSubscription(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, unsubscribe it!"
          cancelBtnText="Cancel"
          showCancel
        >
          Do you want to unsubscribe ?
        </SweetAlert>
      ),
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.chargeSubscription(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, charge it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will charge Subscription for that Order now !
        </SweetAlert>
      ),
    });
  }
  downloadpre(url) {
    if (url != "") {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", url);
      // document.body.appendChild(link)
      link.click();
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h3>No prescription uploaded!</h3>
          </SweetAlert>
        ),
      });
      // alert("No prescription uploaded")
    }
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  chargeSubscription(id) {
    this.setState({
      processing: true,
    });
    // const FileDownload = require('js-file-download');
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    ChargeSubscriptionOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.setState({
          show_charge_message: true,
          charge_message: res.data.message,
          processing: false,
        });

        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  cancelSubscription(id) {
    // const FileDownload = require('js-file-download');
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    CancelSubscriptionOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  viewpdf(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true }, () => {
      DownloadOrder(id, obj).then((res) => {
        this.setState({
          //    pdfloading: false,
        });
        var ddata = res.data.data.pdf_url;
        return <a href={ddata} target="_balnk"></a>;
      });
    });
  }
  deleteorderdetails(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    DeleteSubscriptionOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  getdata(url) {
    this.setState({ page: url });
    this.searchData();
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });

    this.searchdata();
  };
  oncancelchnage = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  onpaymentchange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
    if (name == "paidamount") {
      var total_amunt = "";
      var paid_amount = "";
      var p_paid_amount = "";
      if (this.state.p_paid_amount == "" || this.state.p_paid_amount == null) {
        p_paid_amount = 0;
      } else {
        p_paid_amount = this.state.p_paid_amount;
      }
      total_amunt =
        parseFloat(this.state.p_total_cost) - parseFloat(p_paid_amount);
      // paid_amount =  parseFloat(value)
      var remain_amount = 0;
      if (value == "") {
        paid_amount = 0;
      } else {
        paid_amount = parseFloat(value);
      }
      remain_amount = parseFloat(total_amunt) - parseFloat(paid_amount);
      remain_amount = remain_amount.toFixed(2);
      this.setState({ remainpaymentamount: remain_amount });
    }
  };
  resetSearch() {
    this.setState({
      package_id: [],
      deliverydate: "",
    });
    this.searchData();
  }
  async editOrder(cus, channel) {
    if (channel == "app") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      // console.log(cus,"<= id || obj =>",obj);
      var review = "1";
      await Updatereview(cus, review, obj).then((res) => {
        //console.log(res,'update view order ')
      });
    }
    this.props.history.push("/admin/subscriptionorder/" + cus);
  }
  searchdata(e) {
    this.setState({ page: "", isdaterangepickerOpen: false });
    this.searchData();
  }
  handleUpdaterider(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];

    if (this.state.bulkSelect != "" && this.state.bulkSelect != null) {
      this.state.order_chk.map((item) => {
        if (item.isChecked) {
          this.state.selected_id.push({ id: item.id });
          sts_arr.push({ id: item.id });
        }
      });

      if (sts_arr.length > 0) {
        updatesubscriptionOrderStatus(sts_arr, obj).then(() => {
          this.searchData();
          this.setState({ selected_id: [] });
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title="Please select order!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            />
          ),
        });
      }
      // }
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please select status!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    }
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var date = "";
    var today = "";

    console.log(this.state.package_id, "package_id");
    var p_data = [];
    if (this.state.package_id.length != 0) {
      this.state.package_id.map((m) => {
        p_data.push(m.value);
      });
    }

    var dtoday = "";
    if (this.state.deliverydate.length != 0) {
      const deliverydate = new Date(this.state.deliverydate);

      var ddd = ("0" + deliverydate.getDate()).slice(-2);
      var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
      var dyyyy = deliverydate.getFullYear();
      dtoday = dyyyy + "-" + dmm + "-" + ddd;
    } else {
      dtoday = "";
    }
    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      subscriptionfilter(p_data, dtoday, this.state.page, obj)
        .then((response) => {
          var data = response.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          let order_chk = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }
          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          response.data.data.map((ele) => {
            ele["isChecked"] = false;
            order_chk.push(ele);
          });
          this.setState({
            order_details: response.data,
            loading: false,
          });
          this.setState({
            order_chk: order_chk,
          });
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
        });
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.searchData();

    this.interval = setInterval(() => this.searchData(), 180000);

    this.setState({
      useraccess: token.role,
    });

    let role = 5;
    getallrider(role, obj).then((res) => {
      const data = res.data;

      var array1 = this.state.rider_details;
      var array2 = array1.concat(data);

      this.setState({
        rider_details: array2,
      });
      let riderItems = [];
      this.state.rider_details.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        rider_data: riderItems,
      });
    });

    getb2b(obj).then((res) => {
      this.setState({ b2bDetails: res.data.data });
    });

    GetSubscription(obj).then((res) => {
      const data = res.data.data;
      // console.log(data,'data');
      this.setState({ package_details: data });
      let hcItems = [];
      data.map((x, i) => {
        hcItems.push({ value: x.id, label: x.title });
      });
      this.setState({
        Package_items: hcItems,
      });
    });
  }
  paymentdetail(id, total_cost, paid_amount) {
    this.setState({
      p_total_cost: "",
      remainpaymentamount: "0",
      paymenttype: "",
      paidamount: "0",
    });
    var p_check_a = "";
    if (paid_amount == null) {
      p_check_a = 0;
    } else {
      p_check_a = paid_amount;
    }
    var r_amount = parseFloat(total_cost) - parseFloat(p_check_a);
    r_amount = r_amount.toFixed(2);
    // total_cost = total_cost.toFixed(2);
    this.setState({
      showpaymentdetailmodal: true,
      p_orderid: id,
      p_total_cost: total_cost,
      p_paid_amount: paid_amount,
      remainpaymentamount: r_amount,
    });
  }
  closepaymentdetailmodal() {
    this.setState({ showpaymentdetailmodal: false, errormessages: [] });
  }
  submitpaymentdetail() {
    this.setState({ errormessages: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var total_amunt = "";
    var paid_amount = "";
    if (this.state.paymenttype == "2") {
      total_amunt = this.state.p_total_cost;
      paid_amount = parseFloat(this.state.paidamount);
      paid_amount = paid_amount.toFixed(2);
    } else if (this.state.paymenttype == "1") {
      paid_amount = "0";
    }
    updatepaymentinfo(
      this.state.paymenttype,
      paid_amount,
      this.state.p_orderid,
      obj
    )
      .then((res) => {
        if (res.data.success == true) {
          this.setState({ loading: true });
          this.setState({ showpaymentdetailmodal: false });
          this.componentDidMount();
        } else if (res.data.success == false) {
          if (res.data.data.length != 0) {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key];
              ermessage.push(data);
            }
            this.setState({ errormessages: ermessage });
            this.setState({ showpaymentdetailmodal: true });
          } else {
            this.handleClick("bl");
          }
        }
      })
      .catch((res) => {
        console.log(res);
      });
  }

  handleAllChecked = (event) => {
    let orders_st = this.state.order_chk;
    orders_st.forEach((st) => (st.isChecked = event.target.checked));
    this.setState({ order_chk: orders_st });
  };
  handleCheckChieldElement = (event) => {
    let orders_st = this.state.order_chk;
    orders_st.forEach((st) => {
      if (st.id == event.target.value) {
        st.isChecked = event.target.checked;
      }
    });
    this.setState({ order_chk: orders_st });
  };
  onStatusChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  submitCancelOrderModal() {
    let error = false;
    if (this.state.ordercancelreason.trim() == "") {
      error = true;
      this.setState({
        ordercancelreasonError: (
          <small className="text-danger">Reason is required.</small>
        ),
      });
    } else {
      this.setState({ ordercancelreasonError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let cancel_arr = [];
      let status_chnage = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          status_chnage.push({ id: item.id, status: this.state.bulkSelect });
          // cancel_arr.push({id:item.id ,cancelreason:this.state.ordercancelreason})
        }
      });
      updateOrderStatus(status_chnage, this.state.ordercancelreason, obj).then(
        () => {
          this.searchData();
        }
      );
      this.setState({
        selected_id: [],
        bulkSelect: "",
        ordercancelreason: "",
        ordercancelreasonError: null,
        cancelorderModal: false,
      });
    }
  }
  closeCancelOrderModal() {
    this.setState({
      selected_id: [],
      bulkSelect: "",
      ordercancelreason: "",
      ordercancelreasonError: null,
    });
    this.setState({ cancelorderModal: false });
    this.searchData();
  }
  submitriderdetailsModal() {
    let error = false;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (this.state.rider_info == null) {
      error = true;
      this.setState({
        rider_infoError: (
          <small className="text-danger">Rider is required.</small>
        ),
      });
    } else {
      this.setState({ rider_infoError: null });
    }
    if (!error) {
      let order_id = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          order_id.push(item.id);
        }
      });
      var dtoday = "";
      if (this.state.deliverydate.length != 0) {
        const deliverydate = new Date(this.state.deliverydate);

        var ddd = ("0" + deliverydate.getDate()).slice(-2);
        var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
        var dyyyy = deliverydate.getFullYear();
        dtoday = dyyyy + "-" + dmm + "-" + ddd;
      } else {
        dtoday = "";
      }
      updateSubscriptionRider(
        order_id,
        this.state.rider_info.value,
        dtoday,
        obj
      ).then((res) => {
        //console.log(res,'add rider');
        this.searchData();
        this.setState({
          selected_id: [],
          ridermodel: false,
          bulkSelect: "",
          rider_info: null,
          rider_infoError: null,
        });
      });
    }
  }
  formatDate(date) {
    return new Date(date);
  }
  closeriderdetailsModal() {
    this.setState({
      selected_id: [],
      ridermodel: false,
      bulkSelect: "",
      rider_info: null,
      rider_infoError: null,
    });
    this.searchData();
  }
  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const payment = <Tooltip id="payment">Complete Order</Tooltip>;
    const charge = <Tooltip id="charge">Charge</Tooltip>;
    const remove = <Tooltip id="remove">Cancel Subscription</Tooltip>;
    const errormessages = this.state.errormessages;
    const order_details = this.state.order_details;
    const order_data = this.state.order_chk;
    //console.log(this.state.order_chk,'order check ');
    const order_status_arr = {
      1: "Submitted",
      2: "Schedule Confirmed",
      3: "Lab Team Dispatched",
      4: "Sample Collected",
      5: "Test Results(Completed)",
      6: "Cancelled",
    };

    const order_delivery_type = { 1: "Normal", 2: "Express" };
    //console.log(order_status_arr[1],"status");
    var c = 1;
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col className="fl_orderlist" md={12}>
              <Card
                tableFullWidth
                content={
                  <React.Fragment>
                    <br />
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Row
                          className="OrderList_fill"
                          style={{
                            borderRadius: "5px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            width: "98%",
                            marginLeft: "7px",
                          }}
                        >
                          <Row>
                            <Col md={12} sm={12} lg={12} xs={12}>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingTop: "4px",
                                  width: "25%",
                                  position: "relative",
                                }}
                              >
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  placeholder="Package"
                                  name="package_id"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  value={this.state.package_id}
                                  onChange={(value) =>
                                    this.setState({
                                      package_id: value,
                                    })
                                  }
                                  options={this.state.Package_items}
                                />
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1 fl_datepicker"
                                style={{ width: "17%" }}
                              >
                                <Datetime
                                  timeFormat={false}
                                  dateFormat="YYYY-MM-DD"
                                  inputProps={{ placeholder: "Delivery Date" }}
                                  closeOnSelect={true}
                                  value={this.state.deliverydate}
                                  onChange={this.handleDateChange}
                                />
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }}
                                  // width="25%"  //bsStyle="info"
                                  fill
                                  onClick={this.searchdata.bind(this)}
                                >
                                  Filter
                                </Button>
                                &nbsp;
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }} //bsStyle="info"
                                  fill
                                  onClick={this.resetSearch.bind(this)}
                                  // width="25%"
                                >
                                  Reset
                                </Button>
                              </Col>
                              <Col
                                md={2}
                                sm={2}
                                lg={2}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }}
                                  fill
                                  disabled={
                                    this.state.deliverydate == ""
                                      ? "disabled"
                                      : ""
                                  }
                                  onClick={this.saverider.bind(this)}
                                >
                                  Add Rider
                                </Button>
                              </Col>
                              <Col
                                md={2}
                                sm={2}
                                lg={2}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }}
                                  fill
                                  disabled={
                                    this.state.deliverydate == ""
                                      ? "disabled"
                                      : ""
                                  }
                                  onClick={this.deliveryDone.bind(this)}
                                >
                                  Update Status
                                </Button>
                              </Col>
                            </Col>
                          </Row>
                        </Row>

                        <br></br>
                        <Col md={12} sm={12} lg={12} xs={12}>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    onClick={this.handleAllChecked}
                                    value="checkedall"
                                  />{" "}
                                </th>
                                <th></th>
                                <th>#Id</th>
                                <th>Subscriber</th>
                                <th>Package</th>
                                <th>Subscription Date</th>
                                <th>Delivery Date</th>
                                <th>Total Cost</th>
                                <th>Payment Status</th>
                                <th>Rider Name</th>
                                <th>Delivery status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {order_data.map((cus) => (
                                    // <tr className={cus.is_viewed_by_admin=="0"? "red_background" : ''}>
                                    <tr>
                                      <td>
                                        <input
                                          key={cus.id}
                                          onClick={
                                            this.handleCheckChieldElement
                                          }
                                          type="checkbox"
                                          checked={cus.isChecked}
                                          value={cus.id}
                                        />{" "}
                                      </td>
                                      <td>
                                        {cus.channel == "app" ? (
                                          <i
                                            className="fa fa-mobile"
                                            style={{ fontSize: "25px" }}
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>{cus.id}</td>
                                      <td>{cus.lead.name}</td>
                                      <td>
                                        {
                                          cus.subscriptionorder_item[0].package
                                            .title
                                        }
                                      </td>
                                      <td>{cus.subscription_date}</td>
                                      {/*<td>{this.formatDate(cus.delivery_date)}</td> */}
                                      <td>{cus.delivery_display_date}</td>
                                      <td>{(cus.total_cost - 0).toFixed(2)}</td>
                                      <td>{cus.payment_status}</td>
                                      {/*
                {cus.order_status == 1 || cus.order_status == 2 || cus.order_status == 3 || cus.order_status == 4 ? 
                   <td className="">
                      <p className="btn btn-fill fl_text_orange">{order_status_arr[cus.order_status]}</p>
                   </td>
                   : cus.order_status ==5 ? 
                   <td className="">
                      <p className="btn btn-fill fl_text_green "> {order_status_arr[cus.order_status]}</p>
                   </td>
                   : cus.order_status == 6   ? <td style={{display: 'inline-flex'}} className="">
                   <p className="btn btn-fill fl_text_red">{order_status_arr[cus.payment_status]}</p>
                   
                   </td>
                   
                   : 
                   <td className="">
                      <p className="btn btn-fill">{order_status_arr[cus.order_status]}</p>
                   </td>
                   } 
                 */}

                                      <td>
                                        {cus.rider_id != null
                                          ? cus.riderdetails != null
                                            ? cus.riderdetails.name
                                            : ""
                                          : ""}
                                      </td>

                                      <td>
                                        {cus.is_delivered == 1 ? "Yes" : "No"}
                                      </td>
                                      <td>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            bsSize="xs"
                                            onClick={this.warningWithConfirmAndCancelMessage2.bind(
                                              this,
                                              cus.id
                                            )}
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                        {cus.payment_status === "failed" && (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={charge}
                                          >
                                            <Button
                                              simple
                                              disabled={this.state.processing}
                                              bsStyle="success"
                                              bsSize="xs"
                                              onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                this,
                                                cus.id
                                              )}
                                            >
                                              <i class="fa fa-check-square-o" />
                                            </Button>
                                          </OverlayTrigger>
                                        )}
                                      </td>
                                      {/* 
                <td style={{'text-align':'center'}}>{cus.short_url == null ? '-' :<a className="btn btn-default "bsSize="xs" href={cus.short_url} target="_blank" >View</a>}</td>
                */}
                                      {/* <td> <Button  //bsStyle="danger"
                   disabled={!this.state.processing} onClick={this.downloadinvoice.bind(this,cus.id)}  >View</Button></td> */}
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                          {this.state.loading ? (
                            ""
                          ) : this.state.noRecordFound ? (
                            ""
                          ) : (
                            <div style={{ textAlign: "center" }}>
                              <Pagination>
                                {!this.state.prevdisabled ? (
                                  <Pagination.First
                                    dataUrl={this.state.prevpage}
                                    onClick={this.getdata.bind(
                                      this,
                                      this.state.prevpage
                                    )}
                                    disabled={this.state.prevdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                                {this.state.paginationData.map((url) => (
                                  <Pagination.Item
                                    dataUrl={url}
                                    active={
                                      this.state.currentPage == c ? "1" : null
                                    }
                                    onClick={this.getdata.bind(this, url)}
                                  >
                                    {c++}
                                  </Pagination.Item>
                                ))}
                                {!this.state.nextdisabled ? (
                                  <Pagination.Last
                                    dataUrl={this.state.nextpage}
                                    onClick={this.getdata.bind(
                                      this,
                                      this.state.nextpage
                                    )}
                                    disabled={this.state.nextdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                              </Pagination>
                            </div>
                          )}
                        </Col>
                        <Modal
                          show={this.state.showpaymentdetailmodal}
                          onHide={() =>
                            this.setState({
                              showpaymentdetailmodal: false,
                              errormessages: [],
                            })
                          }
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Payment Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <form>
                              {errormessages.length != 0 && (
                                <div className=" alert alert-danger">
                                  {errormessages.map((data) => (
                                    <React.Fragment>
                                      <li>{data}</li>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              <FormGroup className="order_source_data">
                                <ControlLabel>Payment type</ControlLabel>
                                &nbsp;
                                <Radio
                                  number="5"
                                  option="1"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "1"}
                                  label="Paid in full"
                                />
                                &nbsp;
                                <Radio
                                  number="6"
                                  option="2"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "2"}
                                  label="Partial Payment"
                                />
                              </FormGroup>
                              {this.state.paymenttype == "2" ? (
                                <>
                                  {this.state.p_paid_amount != null &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      Paid Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_paid_amount - 0).toFixed(
                                          2
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.remainpaymentamount != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Pending Amount :{" "}
                                      <b>
                                        {" "}
                                        {(
                                          this.state.remainpaymentamount - 0
                                        ).toFixed(2)}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.p_total_cost != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Total Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_total_cost - 0).toFixed(
                                          2
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  <FormGroup>
                                    <ControlLabel>Amount</ControlLabel>
                                    <FormControl
                                      type="number"
                                      min={0}
                                      value={this.state.paidamount}
                                      onChange={this.onpaymentchange}
                                      name="paidamount"
                                      placeholder="0.00"
                                    ></FormControl>
                                  </FormGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </form>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.closepaymentdetailmodal.bind(this)}
                            >
                              Close
                            </Button>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={this.submitpaymentdetail.bind(this)}
                            >
                              Submit
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.show_charge_message}
                          onHide={() =>
                            this.setState({ show_charge_message: true })
                          }
                        >
                          <Modal.Body>
                            <p> {this.state.charge_message} </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={() =>
                                this.setState({ show_charge_message: false })
                              }
                            >
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancel_reason_display_Modal}
                          onHide={() =>
                            this.setState({ cancel_reason_display_Modal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Order Cancel</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              Cancel Reason : {this.state.Cancel_reason_state}{" "}
                            </p>
                          </Modal.Body>
                          <Modal.Footer>
                            {/* <Button bsStyle="danger" fill onClick={this.close_cancel_reason_display_Modal.bind(this)}>Cancel</Button> */}
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancelorderModal}
                          onHide={() =>
                            this.setState({ cancelorderModal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Cancel Order</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>Cancel Order Reason</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.ordercancelreason}
                                onChange={this.oncancelchnage}
                                name="ordercancelreason"
                                placeholder="Cancel Reason"
                              ></FormControl>
                              {this.state.ordercancelreasonError}
                            </FormGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitCancelOrderModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeCancelOrderModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.ridermodel}
                          onHide={() => this.setState({ ridermodel: true })}
                        >
                          <Modal.Header>
                            <Modal.Title>Rider Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>Select Rider</ControlLabel>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                placeholder="Rider"
                                //style={{ width:"10%" }}
                                name="rider_info"
                                value={this.state.rider_info}
                                onChange={(value) =>
                                  this.setState({
                                    rider_info: value,
                                  })
                                }
                                options={this.state.rider_data}
                                // options={[
                                //   {value: '1',label : 'axay'},
                                //   {value: '2',label : 'jaimin'},
                                // ]}
                              />
                              {this.state.rider_infoError}
                            </FormGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitriderdetailsModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeriderdetailsModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default subscriptionpackagefilter;
